import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { setTasksStatus } from "../../../redux/ducks/task";

const SetTaskStatus = props => {
    const [show, hide, renderModal] = useModal();
    const [d_setTasksStatus, d_status, error, event] = useStatusThunk(setTasksStatus);
    const [status, setStatus] = useState();

    event.onSuccess = () => {
        hide();
        setStatus(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Set Status</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Type</div>
                        <select className="select select--primary" onChange={e => setStatus(e.target.value)}>
                            <option disabled selected></option>
                            <option value="translating">Translating</option>
                            <option value="editing">Editing</option>
                            <option value="completed">Completed</option>
                            <option value="delivered">Delivered</option>
                        </select>
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={d_status == "pending"} className="button--primary" onClick={() => { d_setTasksStatus({ taskIDs: props.selectedTasks, status }) }}>Set Status</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default SetTaskStatus;